import { NativeBiometric } from 'capacitor-native-biometric';

export function getCredentials(socketUrl) {
  return new Promise((resolve) => {
    const server = `www.${new URL(socketUrl).hostname.toString()}`;

    NativeBiometric.isAvailable().then(async ({ isAvailable }) => {
      try {
        if (!isAvailable) {
          return resolve();
        }

        // Get user's credentials
        await NativeBiometric.getCredentials({ server }).then((credentials) => {
          resolve(credentials);
        });
      } catch (err) {
        console.error(err);
        resolve();
      }
    });
  });
}

export function setCredentials(socketUrl, email, password) {
  return new Promise((resolve) => {
    const server = `www.${new URL(socketUrl).hostname.toString()}`;

    NativeBiometric.isAvailable().then(async ({ isAvailable }) => {
      try {
        if (!isAvailable) {
          return resolve();
        }

        await NativeBiometric.setCredentials({
          username: email,
          password,
          server
        });

        resolve();
      } catch (err) {
        console.error(err);
        resolve();
      }
    });
  });
}

export function deleteCredentials(socketUrl) {
  return new Promise((resolve) => {
    const server = `www.${new URL(socketUrl).hostname.toString()}`;

    NativeBiometric.isAvailable().then(async ({ isAvailable }) => {
      try {
        if (!isAvailable) {
          return resolve();
        }

        await NativeBiometric.deleteCredentials({ server });

        resolve();
      } catch (err) {
        console.error(err);
        resolve();
      }
    });
  });
}

export async function getBiometricMethod() {
  const result = await NativeBiometric.isAvailable();
  let method;
  switch (result.biometryType) {
    case 1:
    case 3:
    case 6:
      method = 'fingerprint';
      break;
    case 2:
    case 4:
    case 5:
      method = 'faceID';
      break;
    default:
      method = null;
      break;
  }
  return method;
}

export function verifyIdentity(credentials) {
  return NativeBiometric.verifyIdentity({
    // ios description
    reason: `Connexion automatique à votre espace via l'identifiant ${credentials.username} ?`,
    title: 'Connexion',
    subtitle: '',
    // android description
    description: `Connexion automatique à votre espace via l'identifiant ${credentials.username} ?`,
    negativeButtonText: 'Se connecter par mot de passe'
  });
}
